import { brand, stats } from "@/mocks/homeData";

type HeroSectionProps = {
  query: string;
  onQueryChange: (value: string) => void;
  onSearch: () => void;
};

const quickTags = ["每日热榜", "影视风云", "网络热梗", "时尚穿搭", "音乐现场"];

export default function HeroSection({ query, onQueryChange, onSearch }: HeroSectionProps) {
  return (
    <section id="home" className="relative w-full pt-16 md:pt-20">
      <div className="relative w-full min-h-[560px] md:min-h-[680px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20banner%20with%20flowing%20crimson%20and%20gold%20light%20ribbons%20over%20deep%20charcoal%20gradient%20background%2C%20glowing%20particles%20and%20soft%20bokeh%2C%20cinematic%20dark%20atmosphere%2C%20no%20text%2C%20high%20detail%2C%20wide%20composition&width=1600&height=900&seq=hl-hero-bg-01&orientation=landscape"
          alt="黑料社娱乐热点频道导航站首屏背景"
          title="黑料社 娱乐热点导航"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/88" />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/40 to-transparent" />

        <div className="relative w-full px-4 md:px-8 py-20 md:py-28">
          <div className="max-w-3xl mx-auto text-center animate-fade-up">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/12 border border-background-50/25 font-label text-xs text-background-100 backdrop-blur">
              <i className="ri-pulse-line text-accent-400" />
              频道导览 · 站点地图 · 一屏直达
            </span>

            <h1 className="mt-6 font-heading font-black text-3xl md:text-5xl lg:text-6xl leading-tight text-background-50">
              {brand.name}
              <span className="block mt-2 text-xl md:text-2xl lg:text-3xl font-bold text-accent-300">
                {brand.slogan}
              </span>
            </h1>

            <p className="mt-5 font-body text-sm md:text-base leading-relaxed text-background-100/90 max-w-2xl mx-auto">
              从娱乐爆料到社会热点，各板块与频道分区全部列在首页。
              不知道去哪找想看的内容？跟着站点地图和导航走，几秒就能定位到目标栏目。
            </p>

            <form
              className="mt-8 max-w-2xl mx-auto"
              onSubmit={(e) => {
                e.preventDefault();
                onSearch();
              }}
              role="search"
            >
              <div className="flex flex-col sm:flex-row items-stretch gap-2 p-2 rounded-lg bg-background-50/10 border border-background-50/25 backdrop-blur">
                <div className="flex-1 flex items-center gap-2 px-3">
                  <span className="w-5 h-5 flex items-center justify-center text-background-200">
                    <i className="ri-search-line text-base" />
                  </span>
                  <input
                    type="search"
                    value={query}
                    onChange={(e) => onQueryChange(e.target.value)}
                    placeholder="搜索频道或主题，例如：影视风云"
                    aria-label="搜索频道或主题"
                    className="w-full bg-transparent py-3 font-label text-sm text-background-50 placeholder:text-background-200/80 focus:outline-none"
                  />
                </div>
                <button
                  type="submit"
                  className="whitespace-nowrap cursor-pointer px-6 py-3 rounded-md bg-primary-500 text-background-50 font-label text-sm hover:bg-primary-600 transition-colors"
                >
                  查找频道
                </button>
              </div>
            </form>

            <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
              <span className="font-label text-xs text-background-200/80">热门频道：</span>
              {quickTags.map((tag) => (
                <button
                  key={tag}
                  type="button"
                  onClick={() => {
                    onQueryChange(tag);
                    onSearch();
                  }}
                  className="cursor-pointer font-label text-xs px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-background-100 hover:bg-accent-500 hover:text-secondary-950 hover:border-accent-500 transition-colors"
                >
                  {tag}
                </button>
              ))}
            </div>
          </div>

          <div className="mt-14 md:mt-20 max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {stats.map((item) => (
              <div
                key={item.label}
                className="rounded-lg bg-background-50/8 border border-background-50/20 backdrop-blur px-4 py-5 text-center"
              >
                <div className="font-heading font-black text-2xl md:text-3xl text-accent-300">
                  {item.value}
                  <span className="text-sm md:text-base ml-1 text-background-100">{item.suffix}</span>
                </div>
                <div className="mt-1.5 font-label text-xs text-background-100/80">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}